module.exports = __webpack_public_path__ + "static/media/about-image-01.81980bb2.png";